import React, { useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

function DeliveryCost() {
  const [delivery, setDelivery] = useState({
    category: "",
    minOrder: "",
    cost: "",
    from: new Date(),
    expiry: new Date(),
    status: "active",
  });

  const [deliveries, setDeliveries] = useState([
    {
      id: 1,
      category: "Electronics",
      minOrder: 50,
      cost: 10,
      from: "2025-01-01",
      expiry: "2025-12-31",
      status: "Active",
    },
    {
      id: 2,
      category: "Footwear",
      minOrder: 30,
      cost: 5,
      from: "2025-01-01",
      expiry: "2025-12-31",
      status: "Active",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDelivery({ ...delivery, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setDelivery({ ...delivery, [name]: date[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newDelivery = {
      ...delivery,
      id: deliveries.length + 1,
      from: delivery.from.toISOString().split("T")[0],
      expiry: delivery.expiry.toISOString().split("T")[0],
      status: delivery.status === "active" ? "Active" : "Inactive",
    };

    setDeliveries([...deliveries, newDelivery]);
    setDelivery({
      category: "",
      minOrder: "",
      cost: "",
      from: new Date(),
      expiry: new Date(),
      status: "active",
    });
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content">
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Delivery Cost Management</div>
          </div>

          {/* Delivery Form */}
          <div className="col-12 mb-4">
            <div className="card shadow-sm">
              {/* <div className="card-header bg-primary text-white ">
                Set Delivery Cost by Category
              </div> */}
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label ">Category</label>
                      <input
                        type="text"
                        className="form-control"
                        name="category"
                        placeholder="Enter Category"
                        value={delivery.category}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label ">Minimum Order (Rs)</label>
                      <input
                        type="number"
                        className="form-control"
                        name="minOrder"
                        placeholder="Enter Minimum Order"
                        value={delivery.minOrder}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label ">Delivery Cost (Rs)</label>
                      <input
                        type="number"
                        className="form-control"
                        name="cost"
                        placeholder="Enter Delivery Cost"
                        value={delivery.cost}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label ">From Date</label>
                      <Flatpickr
                        value={delivery.from}
                        onChange={(date) => handleDateChange("from", date)}
                        options={{ dateFormat: "Y-m-d" }}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label ">Expiry Date</label>
                      <Flatpickr
                        value={delivery.expiry}
                        onChange={(date) => handleDateChange("expiry", date)}
                        options={{ dateFormat: "Y-m-d" }}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label ">Status</label>
                      <select
                        className="form-select"
                        name="status"
                        value={delivery.status}
                        onChange={handleChange}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>

                    <div className="col-12 text-end mt-2">
                      <button type="submit" className="btn btn-primary">
                        Save Delivery Cost
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Delivery Table */}
          <div className="col-12">
            <div className="card shadow-sm">
               
              <div className="card-body table-responsive">
                <table className="table table-hover table-striped align-middle">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Category</th>
                      <th>Min Order ($)</th>
                      <th>Delivery Cost ($)</th>
                      <th>From</th>
                      <th>Expiry</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deliveries.map((d) => (
                      <tr key={d.id}>
                        <td>{d.id}</td>
                        <td>{d.category}</td>
                        <td>{d.minOrder}</td>
                        <td>{d.cost}</td>
                        <td>{d.from}</td>
                        <td>{d.expiry}</td>
                        <td>
                          <span
                            className={`badge ${
                              d.status === "Active" ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {d.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default DeliveryCost;
